import ToolFooter from './ToolFooter';

export default ToolFooter;
